(function () {
  'use strict';

  let variants = [];
  let selectedOptions = [];
  let qty = 1;

  function init() {
    const jsonEl = document.querySelector('#gulp-variants-json');
    if (!jsonEl) return;

    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
      bindScroll();
    }

    const firstVariant = variants.find(v => v.available) || variants[0];
    if (firstVariant) selectedOptions = firstVariant.options.slice();

    bindToggles();
    bindOptions();
    bindQty();
    bindForm();
  }

  function bindToggles() {
    document.querySelectorAll('.gulp-card__row-toggle').forEach(toggle => {
      toggle.addEventListener('click', () => {
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));

        document.querySelectorAll('.gulp-card__row-toggle').forEach(t => t.setAttribute('aria-expanded', 'false'));
        document.querySelectorAll('.gulp-card__options').forEach(p => p.hidden = true);

        if (!isExpanded && panel) {
          toggle.setAttribute('aria-expanded', 'true');
          panel.hidden = false;
        }
      });
    });
  }

  function bindOptions() {
    document.querySelectorAll('.gulp-card__opt-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const optionIndex = parseInt(btn.dataset.optionIndex, 10);
        const value = btn.dataset.optionValue;

        selectedOptions[optionIndex] = value;

        const group = btn.closest('.gulp-card__options');
        group.querySelectorAll('.gulp-card__opt-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        const valEl = document.querySelector('#gulp-opt-val-' + (optionIndex + 1));
        if (valEl) valEl.textContent = value;

        group.hidden = true;
        const toggle = document.querySelector('[aria-controls="' + group.id + '"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');

        const matched = variants.find(v => v.options.every((opt, i) => opt === selectedOptions[i]));
        if (matched) updateVariant(matched);
      });
    });
  }

  function updateVariant(variant) {
    const variantInput = document.querySelector('#gulp-variant-id');
    if (variantInput) variantInput.value = variant.id;

    const priceEl = document.querySelector('#gulp-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);

    const atcBtn = document.querySelector('#gulp-atc-btn');
    const atcText = document.querySelector('.gulp-card__atc-text');
    if (atcBtn && atcText) {
      atcBtn.disabled = !variant.available;
      atcText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function bindQty() {
    const minus = document.querySelector('#gulp-qty-minus');
    const plus = document.querySelector('#gulp-qty-plus');
    const display = document.querySelector('#gulp-qty-display');
    const input = document.querySelector('#gulp-qty-input');
    if (!minus || !plus) return;

    minus.addEventListener('click', () => {
      if (qty <= 1) return;
      qty--;
      display.textContent = qty;
      input.value = qty;
    });

    plus.addEventListener('click', () => {
      qty++;
      display.textContent = qty;
      input.value = qty;
    });
  }

  function bindForm() {
    const form = document.querySelector('#gulp-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const variantId = document.querySelector('#gulp-variant-id')?.value;
      const quantity = parseInt(document.querySelector('#gulp-qty-input')?.value || '1', 10);
      if (!variantId) return;

      const btn = document.querySelector('#gulp-atc-btn');
      const text = document.querySelector('.gulp-card__atc-text');
      if (btn) btn.disabled = true;
      if (text) text.textContent = '...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity }),
        });

        if (!res.ok) throw new Error('Failed');

        const data = await res.json();
        showToast('Added to bag');
        document.dispatchEvent(new CustomEvent('gulp:cart:added', { detail: data }));

      } catch (err) {
        showToast('Something went wrong');
      } finally {
        if (btn) btn.disabled = false;
        if (text) text.textContent = 'Add to Bag';
      }
    });
  }

  function showToast(message) {
    const toast = document.querySelector('#gulp-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    setTimeout(() => toast.classList.remove('is-visible'), 2400);
  }

  function formatMoney(cents) {
    const amount = cents / 100;
    return '£' + (Number.isInteger(amount) ? amount : amount.toFixed(2));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
function bindScroll() {
  const card = document.querySelector('#gulp-card');
  const grid = document.querySelector('.gulp-grid');
  if (!card || !grid) return;

  window.addEventListener('scroll', () => {
    const gridBottom = grid.getBoundingClientRect().bottom;
    const windowHeight = window.innerHeight;

    if (gridBottom <= windowHeight) {
      const offset = windowHeight - gridBottom;
      card.style.bottom = (20 / 100 * windowHeight + offset) + 'px';
    } else {
      card.style.bottom = '20vh';
    }
  }, { passive: true });
}

})();